module.exports = __webpack_public_path__ + "static/media/qmas_logo_small_words.808b0ee4.png";